import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import React, {useState} from "react";
import {GradientButton} from "./GradientComponents";

const PartneringInterestModal = ({email, open, onClose}: {
    email: string,
    open: boolean,
    onClose: () => void
}) => {
    const [isOpen, setIsOpen] = useState(open);

    return (
        <Dialog open={isOpen}>
            <DialogContent>
                <DialogContentText>
                    Thank you for your interest! Please click <b>Confirm</b>, and we will reach out to you via email to
                    chat more about partnership.
                </DialogContentText>
                <DialogActions>
                    <GradientButton style={{
                        minWidth: 140
                    }}
                                    onClick={() => {
                                        setIsOpen(false)
                                        onClose();
                                    }}>Cancel</GradientButton>
                    <GradientButton gradientBackground={true}
                                    style={{
                                        minWidth: 140
                                    }}
                                    onClick={() => {
                                        // @ts-ignore
                                        const pendo = window.pendo;
                                        if (pendo) {
                                            pendo.track("PartneringInterest", {});
                                        }
                                        setIsOpen(false);
                                        onClose();
                                    }}>Confirm</GradientButton>
                </DialogActions>
            </DialogContent>

        </Dialog>
    )
};

export default PartneringInterestModal;
